<template>
    <div v-if="isActif">
        <button
            v-if="!panneauOuvert"
            type="button"
            class="regles-panneau__bouton-ouvrir"
            :title="$t('regles_gestion.ouvrir')"
            @click="ouvrir"
        >
            RDG
        </button>
        <div v-else class="regles-panneau">
            <div class="regles-panneau__entete">
                <span>Règles de gestion de la page</span>
                <button type="button" class="regles-panneau__fermer" @click="fermer">&times;</button>
            </div>
            <div class="regles-panneau__contenu">
                <template v-if="regles.length">
                    <div v-for="regle in regles" :key="regle.cle" class="regles-panneau__item" @click="mettreEnAvant(regle.cle)">
                        <div class="regles-panneau__item-titre">{{ regle.titre }}</div>
                        <div class="regles-panneau__item-texte">{{ regle.texte }}</div>
                    </div>
                </template>
                <p v-else class="regles-panneau__vide">{{ $t('regles_gestion.aucune') }}</p>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { REGLES_GESTION, RegleGestion, SECTIONS } from '@/regles/reglesGestion';
import { REGLES_GESTION as REGLES_GESTION_MUTATIONS } from '@/modules/ReglesGestion/store/mutation-types';

export default defineComponent({
    name: 'ReglesPanneau',
    computed: {
        isActif(): boolean {
            return this.$store.getters['reglesGestionState/isActif'];
        },
        panneauOuvert(): boolean {
            return this.$store.getters['reglesGestionState/isPanneauOuvert'];
        },
        regles(): RegleGestion[] {
            // route définie (ex. "/suivi-demandes-devis/:id"), pas le chemin résolu, pour matcher les routes dynamiques
            const route = this.$router.currentRoute.value.matched[0]?.path ?? this.$router.currentRoute.value.path;
            return REGLES_GESTION.filter(regle => SECTIONS[regle.section].route === route);
        },
    },
    methods: {
        ouvrir() {
            this.$store.commit(`reglesGestionState/${REGLES_GESTION_MUTATIONS.SET_PANNEAU_OUVERT}`, true);
        },
        fermer() {
            this.$store.commit(`reglesGestionState/${REGLES_GESTION_MUTATIONS.SET_PANNEAU_OUVERT}`, false);
        },
        mettreEnAvant(cle: string) {
            this.$store.commit(`reglesGestionState/${REGLES_GESTION_MUTATIONS.SET_CLE_MISE_EN_AVANT}`, cle);
            const pastille = document.querySelector(`[data-regle-cle="${cle}"]`);
            pastille?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setTimeout(() => {
                if (this.$store.getters['reglesGestionState/getCleMiseEnAvant'] === cle) {
                    this.$store.commit(`reglesGestionState/${REGLES_GESTION_MUTATIONS.SET_CLE_MISE_EN_AVANT}`, null);
                }
            }, 2400);
        },
    },
});
</script>

<style scoped>
.regles-panneau__bouton-ouvrir {
    position: fixed;
    bottom: 24px;
    /* côte à côte avec le chatbot (widget tiers, bulle ~70px en bas à droite) : "Règles des menus" puis RDG */
    right: 100px;
    z-index: 1005;
    border-radius: 24px;
    border: none;
    padding: 10px 16px;
    background-color: var(--bleu-secondaire);
    color: #fff;
    font-weight: bold;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
    cursor: pointer;
}
.regles-panneau {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    width: 380px;
    max-width: 90vw;
    background-color: #fff;
    box-shadow: -4px 0 12px rgba(0, 0, 0, 0.2);
    z-index: 1005;
    display: flex;
    flex-direction: column;
}
.regles-panneau__entete {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px;
    background-color: var(--bleu-prinicipal);
    color: #fff;
    font-weight: bold;
}
.regles-panneau__fermer {
    background: none;
    border: none;
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    line-height: 1;
}
.regles-panneau__contenu {
    flex: 1;
    overflow-y: auto;
    padding: 8px 0;
}
.regles-panneau__item {
    padding: 10px 16px;
    border-bottom: 1px solid #e5e7eb;
    cursor: pointer;
}
.regles-panneau__item:hover {
    background-color: #f3f4f6;
}
.regles-panneau__item-titre {
    font-weight: bold;
    color: var(--bleu-prinicipal);
    margin-bottom: 2px;
}
.regles-panneau__item-texte {
    font-size: 13px;
    color: #374151;
}
.regles-panneau__vide {
    padding: 16px;
    color: #6b7280;
    font-size: 13px;
}
</style>
